import * as React from 'react';
import { useResponsive } from '@pkvsinha/react-hooks';
import { Navigate } from '@pkvsinha/react-navigate';

function MobileLayout({ title, subtitle, image, href }) {
    return (React.createElement("div", { className: "p-4" },
        React.createElement("div", { className: "text-6xl my-8" }, title),
        React.createElement("p", { className: "text-slate-900 my-4" }, subtitle),
        React.createElement(Navigate, { to: href, className: "my-8 py-6 uppercase justify-center rounded-lg w-32 h-12 shadow-lg shadow-orange-500 text-white flex items-center bg-orange-600" }, "Read")));
}
function Slide({ title, subtitle, image, href }) {
    return (React.createElement(MobileLayout, { title: title, subtitle: subtitle, image: image, href: href }));
}
function SlideList(props) {
    const { activeIndex, data } = props;
    return (React.createElement("ul", { className: "flex m-4 space-x-2 justify-center" }, data.map(({ title, image }, index) => (React.createElement("li", { key: `${title}` },
        React.createElement("i", { className: `${activeIndex === index ? "fa-solid text-sm" : "fa-regular text-xs"} fa-circle` }))))));
}
function Carousel(props) {
    const { data } = props;
    const { length } = data;
    const [activeIndex, setActiveIndex] = React.useState(0);
    const [small, medium, large] = useResponsive();
    // console.log("small = ", small, ", medium = ", medium, ", large = ", large);
    React.useEffect(() => {
        const intervalId = setInterval(() => {
            setActiveIndex((index) => (index + 1) % length);
        }, 6000);
        return () => {
            clearInterval(intervalId);
        };
    }, [length]);
    return (React.createElement("div", { className: "flex flex-col justify-around h-full" },
        React.createElement(SlideList, { data: data, activeIndex: activeIndex }),
        React.createElement(Slide, { small: small, medium: medium, large: large, title: data[activeIndex].title, subtitle: data[activeIndex].subtitle, image: data[activeIndex].image, href: data[activeIndex].href })));
}

export { Carousel };
//# sourceMappingURL=index.js.map
